/**
 * @generated SignedSource<<99f9b037cf7fa60e2dfcebe731555721>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerSectionTopHomeV2Section$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "headerSectionTopHomeV2Section";
};
export type headerSectionTopHomeV2Section$key = {
  readonly " $data"?: headerSectionTopHomeV2Section$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerSectionTopHomeV2Section",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Section",
  "abstractKey": null
};

(node as any).hash = "2b856921199b65ee84418bf1d40df9f2";

export default node;
